import { useQuery } from 'react-query';
import RdBudgetFormService from '../../../services/rdBudgetFormService';

export const createOrUpdate = (
  organizationId,
  propertyId,
  rentForecastId,
  data,
) => {
  const rdBudgetFormService = new RdBudgetFormService();

  return rdBudgetFormService.createOrUpdateSignature(
    organizationId,
    propertyId,
    rentForecastId,
    data,
  );
};

export const useRdBudgetSignatureQuery = (
  organizationId,
  propertyId,
  rentForecastId,
  options,
) => {
  const queryKey = ['useRdBudgetSignatureQuery', rentForecastId];

  return useQuery(
    queryKey,
    () =>
      new RdBudgetFormService().getSignature(
        organizationId,
        propertyId,
        rentForecastId,
      ),
    {
      enabled: false,
      refetchOnWindowFocus: false,
      ...options,
    },
  );
};
